import React, { useEffect, useState } from "react";
import LeagueFunds from "../components/leagueLocker/leagueFunds";
import { useParams, useNavigate } from "react-router-dom";
import { getLeagueBySlug } from "../components/leagueLocker/firestoreQuery";
import SelectPunishment from "../components/leagueLocker/SeasonChallengeSelectPunishmentPage";
import LeagueAdditionalDetails from "../components/leagueLocker/leagueAdditionalDetails";
import { useAuth } from "../contexts/AuthContext";
import StyledLoadingSpinner from "../components/ui/StyledLoadingSpinner";

const SeasonChallengePage: React.FC = () => {
  const { leagueUrl } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [leagueData, setLeagueData] = useState<any>(null);
  const [errorText, setErrorText] = useState<string | null>(null);
  const [selectedTab, setSelectedTab] = useState(1);
  const { user } = useAuth();

  useEffect(() => {
    const fetchLeagueDetails = async () => {
      if (leagueUrl) {
        try {
          const res = await getLeagueBySlug(leagueUrl);
          if (res) {
            setLeagueData(res);
          } else {
            setErrorText("No league found");
          }
        } catch (error) {
          setErrorText(error as string);
        }
      }
      setIsLoading(false);
    };
    fetchLeagueDetails();
  }, [leagueUrl, selectedTab]);

  useEffect(() => {
    if (leagueData) {
      // Check if the logged-in user is the commissioner
      if (leagueData.createdBy !== user?.uid) {
        navigate("/dashboard");
        return;
      }
    }
  }, [leagueData]);

  return (
    <div className="pageWrapper haveFloatingBtn">
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
            width: "100%",
          }}
        >
          <StyledLoadingSpinner />
        </div>
      ) : (
        <>
          {errorText ? (
            <div>No League Found </div>
          ) : (
            <>
              <ul className="stepWrap">
                <li className={selectedTab <= 3 ? "active" : ""}></li>
                <li
                  className={
                    selectedTab === 2 || selectedTab === 3 ? "active" : ""
                  }
                ></li>
                <li className={selectedTab === 3 ? "active" : ""}></li>
              </ul>
              {selectedTab === 1 && (
                <LeagueFunds
                  leagueData={leagueData}
                  setSelectedTab={setSelectedTab}
                />
              )}
              {selectedTab === 2 && (
                <SelectPunishment
                  leagueData={leagueData}
                  setSelectedTab={setSelectedTab}
                />
              )}
              {selectedTab === 3 && (
                <LeagueAdditionalDetails
                  leagueData={leagueData}
                  setSelectedTab={setSelectedTab}
                />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SeasonChallengePage;
